import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

class Notifier {
  success(message) {
    Vue.$toast({
      component: ToastificationContent,
      position: 'top-right',
      props: {
        title: 'Sucesso',
        icon: 'CheckIcon',
        variant: 'success',
        text: message,
      },
    })
  }

  error(error) {
    const message = error instanceof Error ? error.message : error
    Vue.$toast({
      component: ToastificationContent,
      position: 'top-right',
      props: {
        title: 'Erro',
        icon: 'XOctagonIcon',
        variant: 'danger',
        text: message,
      },
    })
  }
}

export default function useNotifier() {
  return new Notifier()
}
